import React from 'react'
import { Box, BoxProps, CircularProgress, Grid } from '@mui/material'
import { DHL_API } from '../api'
import { useQuery } from '@tanstack/react-query'
import { QueryKey } from '../constants'

type CombinedBoxAndImageProps = Omit<BoxProps, 'color' | 'height' | 'onAbort'> &
  Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'onAbort'> & {
    onAbort?: React.ImgHTMLAttributes<HTMLImageElement>['onAbort']
  }

interface LoadableImageProps extends CombinedBoxAndImageProps {
  blobId: string
  noLoading?: boolean
}

const LoadableImage = (props: LoadableImageProps) => {
  const { blobId = null, noLoading, ...rest } = props

  const { data: imageBlob, isFetching } = useQuery(
    [QueryKey.ImageBlob, blobId],
    async () => {
      const response = DHL_API.get(`api/fleet/storegear/files/${blobId}`, {
        responseType: 'blob',
      })

      return (await response).data
    },
    {
      enabled: !!blobId,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  )

  if (isFetching && !noLoading) {
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ height: '100%' }}
      >
        <CircularProgress />
      </Grid>
    )
  }

  if (!imageBlob) {
    return <Box component="img" {...rest} />
  }

  const finalProps = { ...rest, src: URL.createObjectURL(imageBlob) }

  return <Box component="img" {...finalProps} />
}

export const OverviewImage = (props: LoadableImageProps) => {}

export default LoadableImage
